"use client";

import { useEffect } from "react";
import { isTacticAppWebView } from "@gettactic/helpers/src/isTacticAppWebView";

/**
 * When running inside the Tactic mobile app WebView, disables pinch-to-zoom
 * globally for a native feel. Areas that need zoom (e.g. maps) opt in via
 * the `data-allow-zoom` attribute or `.allow-zoom` class.
 */
export const MobileWebViewManager: React.FC = () => {
  useEffect(() => {
    if (!isTacticAppWebView()) return;

    // Set viewport to prevent zoom
    let meta = document.querySelector<HTMLMetaElement>(
      'meta[name="viewport"]'
    );
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "viewport";
      document.head.appendChild(meta);
    }
    meta.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";

    // Add CSS to disable touch zoom globally, except for elements that opt in
    const style = document.createElement("style");
    style.textContent = `
      body { touch-action: pan-x pan-y; }
      .allow-zoom, [data-allow-zoom] { touch-action: auto; }
    `;
    document.head.appendChild(style);

    // Block iOS gesture-based zoom (pinch)
    const preventGesture = (e: Event) => {
      e.preventDefault();
    };
    document.addEventListener("gesturestart", preventGesture, {
      passive: false
    });
    document.addEventListener("gesturechange", preventGesture, {
      passive: false
    });
    document.addEventListener("gestureend", preventGesture, {
      passive: false
    });

    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
      style.remove();
    };
  }, []);

  return null;
};
